<db-dialog-wrapper [dialog]="this" [width]="'700px'"
                   [height]="(type.value === 'CNAME' || type.value === 'SPF' || type.value === 'PTR') && !gmailMxRecord ? 'inherit' : null "
                   [canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading">
  <div class="db-add-dns-dialog">
    <div class="mb40">
      <div class="db-add-dns-dialog-title"
           *ngIf="!gmailMxRecord && !zohoMxRecord && !record?.id">{{'text_addDnsRecord' | dbText}}</div>
      <div class="db-add-dns-dialog-title" *ngIf="gmailMxRecord">{{'text_addGmailRecord' | dbText}}</div>
      <div class="db-add-dns-dialog-title" *ngIf="zohoMxRecord">{{'text_addZohoRecord' | dbText}}</div>
      <div class="db-add-dns-dialog-title"
           *ngIf="!gmailMxRecord && !zohoMxRecord && record?.id">{{'text_editDnsRecord' | dbText}}</div>
      <div class="db-add-dns-dialog-description" *ngIf="!gmailMxRecord && !zohoMxRecord && !record?.id">Select a record type to add a new record.</div>
    </div>
    <div class="db-add-dns-dialog__content-wrapper">
      <div class="db-add-dns-dialog__content"
           dbCustomScrollbar
           [ngClass]="{'db-add-dns-dialog__content-with-border': isScrolling && !gmailMxRecord && !zohoMxRecord && !record?.id, extendHeight: type.value === 'TXT'}">
        <div class="db-add-dns-dialog-body"
             [ngClass]="{'gmail-zoho' : gmailMxRecord || zohoMxRecord, 'txt-record': (type.value === 'TXT')}">
          <form>
            <div [formGroup]="addRecordForm">

              <div *ngIf="gmailMxRecord || zohoMxRecord" class="db-add-dns-dialog__gmail-record">
                <div>
                  <p>{{ 'text_type' | dbText }}</p>
                  <div class="gmail-record-value">
                    <p>MX</p>
                  </div>
                </div>

                <div>
                  <p>{{ 'text_name' | dbText }}</p>
                  <div class="gmail-record-value">
                    <p>{{ this.zone.name | middleEllipsis : 25 }}</p>
                  </div>
                </div>

                <div>
                  <p>{{ 'text_value' | dbText }}</p>
                  <div class="gmail-record-value">
                    <p [innerHTML]="zohoMxRecord  ? (zohoMxRecordValue | breakText) : (gmailMxRecordValue | breakText)"></p>
                  </div>
                </div>

                <div>
                  <p>TTL</p>
                  <div class="gmail-record-value extended">
                    <p>3600</p>
                  </div>
                </div>
              </div>

              <div *ngIf="!gmailMxRecord && !zohoMxRecord" class="db-add-dns-dialog__add-record"
                   [ngClass]="{'add-padding': type.value === 'A' || type.value === 'MX' || type.value === 'SRV' || type.value === 'AAAA' || type.value === 'CNAME' || type.value === 'SPF' || type.value === 'PTR'}">
                <div>
                  <div class="form-field type-field" [ngClass]="{'form-data-center': showInstallMode}">
                    <div class="field-title without-desc" [innerHTML]="'text_type' | dbText"></div>
                    <ds-dropdown
                      class="select-component"
                      [formControl]="type"
                      [value]="type.value"
                      [dsDropdownOptions]="typesOptions">
                    </ds-dropdown>
                  </div>

                  <div class="input-wrap input-subdomain-field form-field has-near-elemnent">
                    <div class="field-title without-desc" [innerHTML]="'text_addRecordsHostname' | dbText"></div>
                    <div class="input-subdomain-field__subdomain combined"
                         [style.border-color]="(addRecordForm?.controls?.subdomain?.invalid || ((type.value === 'CNAME') && type.value !== 'MX' && addRecordForm?.controls?.subdomain?.value==='')) && formSubmitted ? '#D41125' : null"
                    >
                      <input formControlName="subdomain"
                             placeholder="Left empty for root"
                             class="ds-input-black"
                             maxlength="63"/>
                      <div class="separator"></div>
                      <div class="zone-name" [dsTooltip]="zone?.name" dsTooltipColor="black">.{{zone?.name}}</div>
                    </div>
                  </div>

                  <div class="form-field type-field" [ngClass]="{'form-data-center': showInstallMode}">
                    <div class="field-title without-desc" [innerHTML]="'text_addRecordsTtl' | dbText"></div>
                    <ds-dropdown class="select-component"
                                 [formControl]="ttl"
                                 [value]="ttl?.value"
                                 [dsDropdownOptions]="ttlOptions">
                    </ds-dropdown>
                  </div>
                </div>

                <ng-container *ngIf="dnsMXRecordValue && record && type.value === 'MX'">
                  <div id="clone_element_0" class="clone_element clone_element_0"
                       *ngFor="let item of dnsMXRecordValue; let i = index">
                    <div class="form-field small-option" [ngClass]="{'form-data-center': showInstallMode}">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsPriority' | dbText"></div>
                      <input [value]="(item | splitSpace)[1] ? (item | splitSpace)[0] : ''"
                             (input)="this.formValueChanged = true"
                             class="ds-input-black" maxlength="63"
                             [style.border-color]="!formValid && formSubmitted ? '#D41125' : null"/>
                    </div>

                    <div class="input-wrap input-subdomain-field form-field has-near-elemnent">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsMailServer' | dbText"></div>
                      <div class="input-subdomain-field__subdomain 1111">
                        <input  [value]="(item | splitSpace)[1] ? (item | splitSpace)[1] : ''"
                                (input)="this.formValueChanged = true"
                               class="ds-input-black holaaa"
                               [style.border-color]="!formValid && formSubmitted ? '#D41125' : null"/>
                      </div>
                    </div>

                    <div class="form-field icon" [ngClass]="{'form-data-center': showInstallMode}">
                      <span class="db-icon db-icon-plus" (click)="addOneMore()"></span>
                      <span class="db-icon db-icon-delete" (click)="removeRecord($event)"></span>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="type.value === 'MX'">
                  <div id="clone_element_0" class="clone_element clone_element_0">
                    <div class="form-field small-option" [ngClass]="{'form-data-center': showInstallMode}">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsPriority' | dbText"></div>
                      <input formControlName="priority" class="ds-input-black" maxlength="63"
                             [style.border-color]="!formValid && formSubmitted ? '#D41125' : null"/>
                    </div>

                    <div class="input-wrap input-subdomain-field form-field has-near-elemnent">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsMailServer' | dbText"></div>
                      <div class="input-subdomain-field__subdomain">
                        <input formControlName="mxValue" class="ds-input-black" maxlength="260"
                               [style.border-color]="!formValid && formSubmitted ? '#D41125' : null"/>
                      </div>
                    </div>

                    <div class="form-field icon" [ngClass]="{'form-data-center': showInstallMode}">
                      <span class="db-icon db-icon-plus" (click)="addOneMore()"></span>
                      <span class="db-icon db-icon-delete" (click)="removeRecord($event)"></span>
                    </div>
                  </div>
                </ng-container>

                <ng-container
                  *ngIf="(type.value === 'A' && dnsARecordValue ) || (dnsAAAARecordValue && type.value === 'AAAA')">
                  <div id="clone_element_0" class="clone_element clone_element_0"
                       *ngFor="let item of (type?.value === 'A' ? dnsARecordValue : dnsAAAARecordValue); let i = index">
                    <div class="form-field small-option" [ngClass]="{'form-data-center': showInstallMode}">
                      <div class="field-title without-input"
                           [innerHTML]="(type.value === 'A' ? 'text_hostingBasicInfoIp' : 'text_hostingBasicInfoIp6') | dbText"></div>
                    </div>

                    <div class="input-wrap input-subdomain-field form-field has-near-elemnent">
                      <div class="field-title without-desc"
                           [innerHTML]="(type.value === 'A' ? 'A record' : 'AAAA record')"></div>
                      <div class="input-subdomain-field__subdomain">
                        <input *ngIf="type.value === 'A'" class="ds-input-black" maxlength="260"
                               [value]="item ? item : ''"
                               (input)="this.formValueChanged = true"
                               [style.border-color]="!formValid && formSubmitted ? '#D41125' : null"/>
                        <input *ngIf="type.value === 'AAAA'" class="ds-input-black"
                               maxlength="260"
                               (input)="this.formValueChanged = true"
                               [value]="item? item : ''"
                               [style.border-color]="!formValid && formSubmitted ? '#D41125' : null"/>
                      </div>
                    </div>

                    <div class="form-field icon" [ngClass]="{'form-data-center': showInstallMode}">
                      <span class="db-icon db-icon-plus" (click)="addOneMore()"></span>
                      <span class="db-icon db-icon-delete" (click)="removeRecord($event)"></span>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="type.value === 'A' || type.value === 'AAAA'">
                  <div id="clone_element_0" class="clone_element clone_element_0">
                    <div class="form-field small-option" [ngClass]="{'form-data-center': showInstallMode}">
                      <div class="field-title without-input"
                           [innerHTML]="(type.value === 'A' ? 'text_hostingBasicInfoIp' : 'text_hostingBasicInfoIp6') | dbText"></div>
                    </div>

                    <div class="input-wrap input-subdomain-field form-field has-near-elemnent">
                      <div class="field-title without-desc"
                           [innerHTML]="(type.value === 'A' ? 'A record' : 'AAAA record')"></div>
                      <div class="input-subdomain-field__subdomain">
                        <input *ngIf="type.value === 'A'" formControlName="value" class="ds-input-black" maxlength="260"
                               [style.border-color]="!formValid && formSubmitted ? '#D41125' : null"/>
                        <input *ngIf="type.value === 'AAAA'" formControlName="aaaavalue" class="ds-input-black"
                               maxlength="260"
                               [style.border-color]="!formValid && formSubmitted ? '#D41125' : null"/>
                      </div>
                    </div>

                    <div class="form-field icon" [ngClass]="{'form-data-center': showInstallMode}">
                      <span class="db-icon db-icon-plus" (click)="addOneMore()"></span>
                      <span class="db-icon db-icon-delete" (click)="removeRecord($event)"></span>
                    </div>
                  </div>
                </ng-container>

                <!--  <div *ngIf="type.value === 'A' || type.value === 'AAAA'">
                    <div class="input-wrap input-subdomain-field form-field full-width">
                      <div class="field-title without-desc" [innerHTML]="(type.value === 'A' ? 'text_hostingBasicInfoIp' : 'text_hostingBasicInfoIp6') | dbText"></div>
                      <div class="input-subdomain-field__subdomain input-subdomain-field__subdomain-txt">
                        <textarea *ngIf="type.value === 'A'" formControlName="value" [value]="addRecordForm.controls?.value.value" class="ds-input-black"  [style.border-color]="(addRecordForm.controls?.value.value.invalid || addRecordForm.controls.value.value === '') && !formValid && formSubmitted ? '#D41125' : null" [placeholder]="ARecordPlaceholder"></textarea>
                        <textarea *ngIf="type.value === 'AAAA'" formControlName="aaaavalue" [value]="addRecordForm.controls?.aaaavalue.value" class="ds-input-black"  [style.border-color]="(addRecordForm.controls?.aaaavalue.value.invalid || addRecordForm.controls.aaaavalue.value === '') && !formValid && formSubmitted ? '#D41125' : null" [placeholder]="AAAARecordPlaceholder"></textarea>
                      </div>
                    </div>
                  </div>-->

                <div *ngIf="type.value === 'CNAME' || type.value === 'PTR'">
                  <div class="input-wrap input-subdomain-field form-field full-width">
                    <div class="field-title without-desc" [innerHTML]="'text_addRecordsServer' | dbText"></div>
                    <div class="input-subdomain-field__subdomain">
                      <input formControlName="ptrvalue" maxlength="255" class="ds-input-black"
                             [style.border-color]="(addRecordForm?.controls?.ptrvalue.value.invalid || addRecordForm?.controls?.ptrvalue.value === '') && formSubmitted ? '#D41125' : null"/>
                    </div>
                  </div>
                </div>

                <div *ngIf="type.value === 'TXT'">
                  <div class="input-wrap input-subdomain-field form-field full-width">
                    <div class="field-title without-desc" [innerHTML]="'text_addRecordsTxtContent' | dbText"></div>
                    <div class="input-subdomain-field__subdomain input-subdomain-field__subdomain-txt">
                    <textarea formControlName="txtValue" [value]="dnsRecordValue" class="ds-input-black"
                              [style.border-color]="(addRecordForm?.controls?.txtValue?.value?.invalid || addRecordForm?.controls?.txtValue?.value === '') && !formValid && formSubmitted ? '#D41125' : null"
                              [placeholder]="txtRecordPlaceholder"></textarea>
                    </div>
                  </div>
                </div>

                <div *ngIf="type.value === 'SPF'">
                  <div class="input-wrap input-subdomain-field form-field full-width">
                    <div class="field-title without-desc" [innerHTML]="'text_addRecordsSpfContent' | dbText"></div>
                    <div class="input-subdomain-field__subdomain">
                      <input formControlName="spfValue" maxlength="255" class="ds-input-black"
                             [style.border-color]="(addRecordForm?.controls?.spfValue?.value?.invalid || addRecordForm?.controls?.spfValue?.value === '') && formSubmitted ? '#D41125' : null"/>
                    </div>
                  </div>
                </div>


                <ng-container *ngIf="dnsSRVRecordValue && record && type.value === 'SRV'">
                  <div id="clone_element_0" class="clone_element" *ngFor="let item of dnsSRVRecordValue; let i = index">
                    <div class="form-field small-option" [ngClass]="{'form-data-center': showInstallMode}">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsPriority' | dbText"></div>
                      <input formControlName="priority" class="ds-input-black"
                             [value]="(item | splitSpace)[0] ? (item | splitSpace)[0] : ''"
                             [style.border-color]="(addRecordForm?.controls?.priority?.invalid && (item | splitSpace)[0] !== '') && formSubmitted ? '#D41125' : null"
                             maxlength="63"/>
                    </div>

                    <div class="form-field small-option has-near-elemnent"
                         [ngClass]="{'form-data-center': showInstallMode}">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsWeight' | dbText"></div>
                      <input formControlName="priority" class="ds-input-black"
                             [value]="(item | splitSpace)[1] ? (item | splitSpace)[1] : ''"
                             [style.border-color]="(addRecordForm?.controls?.priority?.invalid && (item | splitSpace)[1] !== '') && formSubmitted ? '#D41125' : null"
                             maxlength="63"/>
                    </div>

                    <div class="form-field small-option" [ngClass]="{'form-data-center': showInstallMode}">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsPort' | dbText"></div>
                      <input formControlName="priority" class="ds-input-black"
                             [value]="(item | splitSpace)[2] ? (item | splitSpace)[2] : ''"
                             [style.border-color]="(addRecordForm?.controls?.priority?.invalid && (item | splitSpace)[2] !== '') && formSubmitted ? '#D41125' : null"
                             maxlength="63"/>
                    </div>

                    <div class="input-wrap input-subdomain-field form-field has-near-elemnent">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsHostname' | dbText"></div>
                      <div class="input-subdomain-field__subdomain">
                        <input formControlName="srvValue" class="ds-input-black"
                               [value]="(item | splitSpace)[3] ? (item | splitSpace)[3] : ''"
                               placeholder="Server hostname"
                               [style.border-color]="(addRecordForm?.controls?.subdomain?.invalid && (item | splitSpace)[3] !== '') && formSubmitted ? '#D41125' : null"
                               maxlength="63"/>
                      </div>
                    </div>

                    <div class="form-field icon" [ngClass]="{'form-data-center': showInstallMode}">
                      <span class="db-icon db-icon-plus" (click)="addOneMore()"></span>
                      <span class="db-icon db-icon-delete" (click)="removeRecord($event)"></span>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="!dnsSRVRecordValue && type.value === 'SRV'">
                  <div id="clone_element_0" class="clone_element">
                    <div class="form-field small-option" [ngClass]="{'form-data-center': showInstallMode}">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsPriority' | dbText"></div>
                      <input formControlName="priority" class="ds-input-black"
                             [style.border-color]="!formValid && formSubmitted ? '#D41125' : null" maxlength="63"/>
                    </div>

                    <div class="form-field small-option has-near-elemnent"
                         [ngClass]="{'form-data-center': showInstallMode}">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsWeight' | dbText"></div>
                      <input formControlName="priority" class="ds-input-black"
                             [style.border-color]="!formValid && formSubmitted ? '#D41125' : null" maxlength="63"/>
                    </div>

                    <div class="form-field small-option" [ngClass]="{'form-data-center': showInstallMode}">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsPort' | dbText"></div>
                      <input formControlName="priority" class="ds-input-black"
                             [style.border-color]="!formValid && formSubmitted ? '#D41125' : null" maxlength="63"/>
                    </div>

                    <div class="input-wrap input-subdomain-field form-field has-near-elemnent">
                      <div class="field-title without-desc" [innerHTML]="'text_addRecordsHostname' | dbText"></div>
                      <div class="input-subdomain-field__subdomain">
                        <input formControlName="srvValue" class="ds-input-black" placeholder="Server hostname"
                               [style.border-color]="!formValid && formSubmitted ? '#D41125' : null" maxlength="63"/>
                      </div>
                    </div>

                    <div class="form-field icon" [ngClass]="{'form-data-center': showInstallMode}">
                      <span class="db-icon db-icon-plus" (click)="addOneMore()"></span>
                      <span class="db-icon db-icon-delete" (click)="removeRecord($event)"></span>
                    </div>
                  </div>
                </ng-container>
              </div>

            </div>
          </form>
        </div>
      </div>
      <div class="db-server-error-wrap " *ngIf="formSubmitted && (serverErrors || !addRecordForm.valid)">
        <div class="db-server-error a"
             *ngIf="formSubmitted && serverErrors && !hasServerFieldErrors">{{serverErrors.message}} <span
          *ngIf="alreadyExistRecord && alreadyExistRecord.type === 'TXT'">You can <span
          (click)="editAlreadyExistTxtRecord()" class="db-txt-link">edit the record</span> and add a new value on separate line.</span>
        </div>
        <div class="db-server-error b"
             *ngIf="formSubmitted && serverErrors && serverErrors.fields.value"> {{serverErrors.fields.value[0]}}</div>
        <div class="db-server-error b"
             *ngIf="formSubmitted && serverErrors && (serverErrors.fields.priority || serverErrors.fields.weight || serverErrors.fields.port)">
          Please fill SRV content.
        </div>
        <div class="db-server-error c"
             *ngIf="formSubmitted && !addRecordForm.valid"> {{'text_fillValidValue' | dbText}}</div>
      </div>
    </div>

    <div class="db-add-dns-dialog-button-wrap">
      <a class="ds-btn ds-btn-m" (click)="cancel()"
         [ngClass]="{'ds-btn-disabled': loading}"><span>{{'text_cancel' | dbText}}</span></a>
      <a class="ds-btn ds-btn-m ds-btn-black" [ngClass]="{'ds-btn-disabled': loading || (!formValueChanged && !gmailMxRecord && !zohoMxRecord)}" (click)="onFormSubmit()">
        <span *ngIf="!loading">{{(record ? 'text_saveTags' : 'text_addRecord') | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
